import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
import Money from './money';
import { computed } from '@ember/object';
import { QuickAmounts as QuickAmountsProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/common/quick_amounts';
export const QuickAmountPreference = new Enum(Object.keys(QuickAmountsProto.QuickAmountPreference));
export default ProtoBaseModel.extend({
  quickAmountPreference: attr(QuickAmountPreference),
  manualAmounts: repeated(Money),
  hasManualAmounts: attr(Boolean),
  displayValueTranslationKey: computed('quickAmountPreference', function () {
    return this.quickAmountPreference === QuickAmountPreference.AUTO || this.quickAmountPreference === QuickAmountPreference.MANUAL ? 'business.devices.profiles.v2.settings.checkout.quickAmount.enabled.on' : 'business.devices.profiles.v2.settings.checkout.quickAmount.enabled.off';
  })
});